<script>
  import $ from '../../vue-gridform/shared/helper'
  import _ from 'lodash'
  const d3 = require('d3')

  export default {
    name: 'VTreemap',
    props: {
      value: {
        type: Object,
        default: () => null
      },
      title: {
        type: String,
        default: ''
      },
      width: {
        type: String,
        default: '640'
      },
      dark: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        uid: null,
        treemap: null,
        svg: null,
        g: null,
        svgTitle: null,
        height: 640
      }
    },

    computed: {
      titleColor() {
        return this.dark ? 'white' : 'black'
      }
    },
    watch: {
      value() {
        this.update()
      },
      width() {
        // const {width, height} = this.size()
        // if (this.svg) this.svg.transition().attr('width', width).attr('height', height)
        // if (this.g) this.g.transition().attr('width', width).attr('height', height)
        this.update()
      },
      dark() {
        this.update()
      }
    },

    created() {
      this.uid = _.uniqueId('vtreemap')
    },
    mounted() {
      this.$nextTick(() => {this.update()})
    },
    updated() {
      this.update()
    },

    methods: {
      // set the dimensions and margins of the graph
      size() {
        const margin = {top: 10, right: 10, bottom: 10, left: 10}
        const width = this.width - margin.left - margin.right
        const height = this.height - margin.top - margin.bottom
        return {width, height, margin}
      },
      update() {
        const data = this.value
        const root = d3.hierarchy(data)
          .sum(d => +d.value)
          .sort((a, b) => b.value - a.value)

        if (this.svg) this.svg.remove()

        const {width, height, margin} = this.size()

        this.treemap = d3.treemap()
          .size([width, height])
          .paddingTop(24)
          .paddingInner(2)
          .round(true)
          (root)

        // append the svg object to the body of the page
        const svg = this.svg = d3.select(`#${this.uid}`)
          .append('svg')
          // Responsive SVG needs these 2 attributes and no width and height attr.
          // .attr('preserveAspectRatio', 'xMinYMin meet')
          // .attr('viewBox', `0 0 ${width} ${height}`)
          // Class to make it responsive.
          // .classed('svg-content-responsive', true)
          .attr('width', this.width)
          .attr('height', this.height)

        const g = this.g = svg
          .append('g')
          .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')')

        // use this information to add rectangles:
        g
          .selectAll('rect')
          .data(root.leaves())
          .enter()
          .append('rect')
          .attr('x', d => d.x0)
          .attr('y', d => d.y0)
          .attr('width', d => d.x1 - d.x0)
          .attr('height', d => d.y1 - d.y0)
          .style('fill', d => {
            return $.percentToColor(d.data.value) || 'transparent'
          })
          .style('cursor', 'pointer')
          .on('click', d => {
            this.$emit('click', d)
          })
          .on('mouseover', d => {
            this.$emit('mouseover', d)
          })
          .on('mouseleave', () => {
            this.$emit('mouseover')
          })

        // and to add the values
        g
          .selectAll('vals')
          .data(root.leaves())
          .enter()
          .append('text')
          .attr('x', d => d.x0 + 1) // to adjust position (more right)
          .attr('y', d => d.y0 + 9) // to adjust position (lower)
          .text(d => {
            const w = d.x1 - d.x0
            const h = d.y1 - d.y0
            return w > 18 && h > 10 ? `${Math.round(d.value)}%` : ''
          })
          .attr('font-size', '9px')
          .attr('fill', 'black')
          .style('pointer-events', 'none') // for rect mouseover event

        // Add title for the groups
        g
          .selectAll('titles')
          .data(root.descendants().filter(d => d.depth === 1))
          .enter()
          .append('text')
          .attr('x', d => d.x0)
          .attr('y', d => d.y0 + 21)
          .text(d => d.data.name)
            .each(function (d) {
                const tl = this.getComputedTextLength() - 24 // TODO check this 24? size of ...?
                const w = d.x1 - d.x0
                if (tl > w) {
                    const l = Math.round(w / 8) // TODO check this 8? char width? use mono font?
                    this.textContent = d.data.name.slice(0, l) + '\u2026'
                }
            })
            .attr('font-size', '13px')
          .attr('fill', this.titleColor)
          .style('cursor', 'pointer')
          .on('click', d => {
            this.$emit('zoom', d)
          })
          .on('mouseover', d => {
            this.$emit('mouseover', d)
          })
          .on('mouseleave', () => {
            this.$emit('mouseover')
          })

        // Add title for the subgroups
        g
          .selectAll('subtitles')
          .data(root.descendants().filter(d => d.depth === 2))
          .enter()
          .append('text')
          .attr('x', d => d.x0)
          .attr('y', d => d.y0 + 18)
          .text(d => d.data.name)
          .each(function(d) {
            const tl = this.getComputedTextLength() - 36 // TODO check this 36?
            const w = d.x1 - d.x0
            if (tl > w) {
              const l = Math.round(w / 8) // TODO check this 8?
              this.textContent = d.data.name.slice(0, l) + '\u2026'
            }
          })
          // .attr('lengthAdjust', 'spacingAndGlyphs')
          // .attr('textLength', d => d.x1 - d.x0)
          .attr('font-size', '10px')
          .attr('fill',  '#777')
          .on('mouseover', d => {
            this.$emit('mouseover', d)
          })
          .on('mouseleave', () => {
            this.$emit('mouseover')
          })

        // Add title
        this.svgTitle = g
          .append('text')
          .attr('x', 0)
          .attr('y', 14)
          .text(this.title)
          .attr('font-size', '20px')
          .attr('fill', this.titleColor)
      }
    }
  }
</script>

<template>
  <div :id="uid"/>
</template>

<style>
  #vtreemapx {
    position: relative;
    display: inline-block;
    width: 100%;
    padding-bottom: 100%; /* aspect ratio */
    overflow: hidden;
    vertical-align: top;
  }
  .svg-content-responsive {
    position: absolute;
    top: 10px;
    left: 0;
    display: inline-block;
  }
</style>
